import React from 'react';
import classNames from 'classnames';

import './Logo.css';

import fullLogo from '../assets/images/tcpt-full-logo.png';
import fullLogoLarge from '../assets/images/tcpt-full-logo@2x.png';
import fullLogoWhite from '../assets/images/tcpt-full-logo-white.png';
import fullLogoLargeWhite from '../assets/images/tcpt-full-logo-white@2x.png';

export function Logo(props) {
  return (
    <div className={ classNames('logo', { 'white' : props.white }) }>
      <img className="color" src={fullLogo} srcSet={`${fullLogo}, ${fullLogoLarge} 2x`} alt="" />
      <img className="white" src={fullLogoWhite} srcSet={`${fullLogoWhite}, ${fullLogoLargeWhite} 2x`} alt="" />
    </div>
  )
}